<template>
  <ResponseContainer>
    <h2>Enter the code given to you:</h2>
    <p>Check your Messenger or WhatsApp!</p>
    <div class="mt-4">
      <input type="text" name="secret" v-model="secret" placeholder="Your code" autocomplete="off">
      <div v-if="error" class="-mt-2 mb-4 text-sm text-red-500">
        {{ error }}
      </div>
      <button @click="goToNext()" :disabled="!secret">Next →</button>
    </div>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'

export default {
  name: 'ResponseNamePage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      secret: undefined,
      error: '',
    }
  },
  beforeMount() {
  },
  methods: {
    async goToNext() {
      const group = await Group.auth(this.secret)
      if (!group) {
        this.error = 'Code is not valid.'
      } else {
        this.$router.push('/')
      }
    },   
  },
}
</script>